import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PresentationIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsxs("svg", {
                    viewBox: "0 0 25 25",
                    children: [
                        _jsx("path", {
                            d: "M4.924 17.977a1 1 0 10-.004 2l.752.002.607 2.591a1 1 0 001.948-.456l-.5-2.13 8.565.02-.51 2.126a1 1 0 001.945.466l.62-2.587.752.002a1 1 0 00.005-2l-1.543-.004-11.094-.026-1.543-.004zM2.05 3.005a2 2 0 012.005-1.996l16 .038a2 2 0 011.995 2.005l-.026 11a2 2 0 01-2.005 1.995l-1-.002a1 1 0 11.005-2l1 .002.026-11-16-.038-.026 11 1 .003a1 1 0 01-.005 2l-1-.003a2 2 0 01-1.995-2.004l.026-11z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M12.033 10.314a1.286 1.286 0 10.006-2.571 1.286 1.286 0 00-.006 2.571zm-.004 1.715a3 3 0 10.014-6 3 3 0 00-.014 6z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        }),
                        _jsx("path", {
                            d: "M8.625 13.494a5.768 5.768 0 018.886 2.92 1 1 0 11-1.906.606 3.768 3.768 0 00-7.177-.017 1 1 0 11-1.903-.615 5.768 5.768 0 012.1-2.894z",
                            fillRule: "evenodd",
                            clipRule: "evenodd"
                        })
                    ]
                })
            })
        ]
    });
};
PresentationIcon.isCarinaIcon = true;
export default PresentationIcon;
